import FirebaseAdapter from "@wc/adapters/firebase";

/**
 * @typedef {object} TeamListItem
 * @property {string} id The team id
 * @property {string} name The team name
 * @property {string} organizationId The org this team belongs to
 * @property {Date} createdAt When the team was created
 */

/**
 * List all teams in an organization that the user can access
 * @param {string} orgId The organization id
 * @param {string} userId The user requesting the list
 * @returns {Promise<TeamListItem[]>} Array of teams
 */
export async function listTeamsByOrg(orgId, userId) {
  // Verify user is a member of the organization
  const isMember = await FirebaseAdapter().membership.checkOrgAccess(
    userId,
    orgId,
  );

  if (!isMember) {
    throw new Error("User is not a member of this organization");
  }

  const teams = await FirebaseAdapter().teams.listTeamsByOrganization(orgId, {
    limit: 100,
  });

  return teams.map((team) => ({
    id: team.id,
    name: team.name,
    organizationId: team.organizationId,
    createdAt: team.createdAt?.toDate
      ? team.createdAt.toDate()
      : team.createdAt,
  }));
}
